import { getUnits } from '@/services/admin/UnitService'

export const namespaced = true

export const state = {
  units: null
}

export const mutations = {
  SET_UNITS(state, units) {
    state.units = units.data
  }
}

export const actions = {
  getUnits({ commit }) {
    return new Promise(resolve => {
      getUnits().then(response => {
        commit('SET_UNITS', response)
        resolve(response.data)
      })
    })
  }
}
